module.exports = __webpack_public_path__ + "static/media/policy_settings.84754f49.svg";